// extracted by mini-css-extract-plugin
export default {"mainReviewsWrapper":"NI-z"};